import React, { useState, useEffect, ReactNode } from 'react';

/**
 * Loads the Font Awesome icons registry via dynamic import so icons are in a
 * separate chunk instead of the main bundle. Renders children only after icons
 * are registered so no <FontAwesomeIcon> runs before library.add().
 */
export const IconsLoader: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [iconsReady, setIconsReady] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setIconsReady(true);
        }, 10000);

        import('@/icons')
            .then(() => setIconsReady(true))
            .catch((err) => {
                console.warn('[IconsLoader] Icons chunk failed to load or execute:', err);
                setIconsReady(true);
            })
            .finally(() => clearTimeout(timeout));

        return () => clearTimeout(timeout);
    }, []);

    if (!iconsReady) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '2rem',
                    textAlign: 'center',
                    backgroundColor: '#f5f5f5',
                    color: '#333',
                }}
            >
                <div
                    style={{
                        width: '40px',
                        height: '40px',
                        border: '3px solid #e0e0e0',
                        borderRadius: '50%',
                        marginBottom: '1rem',
                    }}
                />
                <div style={{ fontSize: '1rem', color: '#666' }}>Loading...</div>
            </div>
        );
    }

    return <>{children}</>;
};
